import AccountDisplay from "@core-components/accountDisplay/AccountDisplay";
import ValorantRegionSelectorBanner from "@core-components/regionSelector/banner/ValorantRegionSelectorBanner";
import type { AppRegion } from "@core-types/region.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Stack } from "@mantine/core";
import { useCallback, useEffect, useMemo, useState } from "react";
import ValorantService from "../../../api/valorant/valorant.service";
import type ValorantProduct from "../types/ValorantProduct";
import ValorantGradientText from "./ValorantGradientText";
import ValorantAccountCard from "./ValorantProductCard";

const ValorantAccountCards = () => {
  const { t } = useAppTranslation("pages.valorant");
  const [products, setProducts] = useState<ValorantProduct[]>([]);
  const { changeRegion } = useAppRegion();

  const handleRegionChange = (newRegion: AppRegion) => {
    changeRegion(newRegion, loadData);
  };

  const loadData = useCallback(() => {
    ValorantService.getAllProducts().then(setProducts);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const renderedProducts = useMemo(
    () =>
      products.map((product) => (
        <ValorantAccountCard key={product.i18nKey} product={product} />
      )),
    [products],
  );

  return (
    <Stack>
      <ValorantRegionSelectorBanner onRegionChange={handleRegionChange} />
      <AccountDisplay.List
        emoji="Trophy"
        className="gap-0"
        label={
          <>
            {" "}
            <ValorantGradientText>{t("listTitle")}</ValorantGradientText>
          </>
        }
      >
        {renderedProducts}
      </AccountDisplay.List>
    </Stack>
  );
};

export default ValorantAccountCards;
